/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiDomainInputFromJSON(json) {
    return ApiDomainInputFromJSONTyped(json, false);
}
export function ApiDomainInputFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'crossDomainEnabled': !exists(json, 'crossDomainEnabled') ? undefined : json['crossDomainEnabled'],
        'domain': !exists(json, 'domain') ? undefined : json['domain'],
    };
}
export function ApiDomainInputToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'crossDomainEnabled': value.crossDomainEnabled,
        'domain': value.domain,
    };
}
